var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 128 128"
    },
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00B8DF;}\n\t.st1{fill:#FF9A30;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#61BEE2;}\n\t.st4{fill:#FD4233;}\n\t.st5{fill:#FF402F;}\n\t.st6{fill:#1D409D;}\n\t.st7{fill:#007732;}\n\t.st8{fill:#FF5A29;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ps"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ai"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Ai_download"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Image_download"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Video"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Video_download"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Ps_download"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Doc"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Doc_download"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Music"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Music_download"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Pdf"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Pdf_download"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Word"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Word_download"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Exel"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M80,96h-8.3l-8-13l-8,13H48l11.4-17.7L48.7,61.7h8l7.4,12.3l7.2-12.3h7.8l-10.8,17L80,96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M104,126H24c-5.5,0-10-4.5-10-10V12c0-5.5,4.5-10,10-10h40.7c2.7,0,5.2,1,7.1,2.9l39.3,39.3     c1.9,1.9,2.9,4.4,2.9,7.1V116C114,121.5,109.5,126,104,126z M24,6c-3.3,0-6,2.7-6,6v104c0,3.3,2.7,6,6,6h80c3.3,0,6-2.7,6-6V51.3     c0-1.6-0.6-3.1-1.8-4.2L68.9,7.8C67.8,6.6,66.3,6,64.7,6H24z"
  }))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Exel_download"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Powerpoint"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Powerpoint_download"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Zip"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Zip_download"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.e148a4f88aa346d8b8e90f001e136556.svg";
export { ForwardRef as ReactComponent };